var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSfh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.3143 54.1678V104.192H29.6858V54.1678L62.6851 22.1565L95.3143 54.1678Z",
    fill: "#E9EAEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6633 29.6702V52.1306L84.4925 41.4921L79.2562 36.5053V29.6702C79.2562 28.3419 80.333 27.2651 81.6613 27.2651H93.2583C94.5865 27.265 95.6633 28.3419 95.6633 29.6702Z",
    fill: "#9EB1B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4924 27.265V41.4921L79.2561 36.5054V29.6703C79.2561 28.3419 80.3329 27.2652 81.6612 27.2652L84.4924 27.265Z",
    fill: "#879BA0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 96.4873V104.192H65.6417V96.4873C65.6417 94.953 66.8862 93.7103 68.4205 93.7103H102.484C104.019 93.7103 105.263 94.9531 105.263 96.4873Z",
    fill: "#9CCE21"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6253 96.4873V104.192H19.7368V96.4873C19.7368 94.953 20.9796 93.7103 22.5138 93.7103H30.8464C32.3825 93.7103 33.6253 94.9531 33.6253 96.4873Z",
    fill: "#9CCE21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.263 99.1055V104.192H65.6417V99.1055C65.6417 97.5713 66.8862 96.3286 68.4205 96.3286H102.484C104.019 96.3284 105.263 97.5713 105.263 99.1055Z",
    fill: "#85C10D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6253 99.1055V104.192H19.7368V99.1055C19.7368 97.5713 20.9796 96.3286 22.5138 96.3286H30.8464C32.3825 96.3284 33.6253 97.5713 33.6253 99.1055Z",
    fill: "#85C10D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3143 56.1315V65.4818L62.5 34.1512L29.6858 65.4818V56.1315L59.8941 27.3616L62.5 24.9404L65.1042 27.3616L95.3143 56.1315Z",
    fill: "#D2D4D8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4995 28.9478L25.1381 64.618L19.9142 60.2322L59.8946 22.1568L62.4995 19.7368L65.1044 22.1568L105.085 60.2322L99.8605 64.618L62.4995 28.9478Z",
    fill: "#EA4756"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3581 66.712H37.7147V104.192H59.3581V66.712Z",
    fill: "#C97523"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.289 66.712H65.6417V88.3554H90.289V66.712Z",
    fill: "#A0D9F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.289 66.712H65.6417V73.2889H90.289V66.712Z",
    fill: "#C97523"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0935 86.6412H51.9517C51.2286 86.6412 50.6426 86.055 50.6426 85.3321C50.6426 84.6091 51.2286 84.0229 51.9517 84.0229H55.0935C55.8166 84.0229 56.4026 84.6091 56.4026 85.3321C56.4026 86.055 55.8166 86.6412 55.0935 86.6412Z",
    fill: "#8E480E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 56.0105C65.8256 56.0105 68.5215 53.3146 68.5215 49.9891C68.5215 46.6635 65.8256 43.9677 62.5001 43.9677C59.1745 43.9677 56.4786 46.6635 56.4786 49.9891C56.4786 53.3146 59.1745 56.0105 62.5001 56.0105Z",
    fill: "#413740"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3583 65.4034H37.7148C36.9916 65.4034 36.4056 65.9896 36.4056 66.7126V104.192H39.0237V68.0215H58.049V104.192H60.6671V66.7124C60.6674 65.9893 60.0814 65.4034 59.3583 65.4034Z",
    fill: "#8E480E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2882 65.4034H65.6415C64.9184 65.4034 64.3324 65.9896 64.3324 66.7126V88.3559C64.3324 89.0789 64.9184 89.665 65.6415 89.665H90.2882C91.0113 89.665 91.5973 89.0789 91.5973 88.3559V66.7124C91.5973 65.9893 91.0113 65.4034 90.2882 65.4034ZM88.979 68.0215V71.9801H66.9506V68.0215H88.979ZM66.9506 87.0468V74.5984H88.979V87.0468H66.9506Z",
    fill: "#8E480E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5001 57.3193C58.458 57.3193 55.1696 54.0309 55.1696 49.9888C55.1696 45.9467 58.458 42.6581 62.5001 42.6581C66.5422 42.6581 69.8307 45.9465 69.8307 49.9888C69.8307 54.0307 66.5422 57.3193 62.5001 57.3193ZM62.5001 45.2763C59.9017 45.2763 57.7878 47.3903 57.7878 49.9888C57.7878 52.5872 59.9017 54.7011 62.5001 54.7011C65.0985 54.7011 67.2124 52.5872 67.2124 49.9888C67.2124 47.3903 65.0985 45.2763 62.5001 45.2763Z",
    fill: "#EA4756"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSfh);
export default __webpack_public_path__ + "static/media/sfh.32d341aee519a92bed476b2f33a98e29.svg";
export { ForwardRef as ReactComponent };